import React from 'react'
import { Modal } from 'react-bootstrap';

const ModalConfirm = ( props ) => {

    const { show, handleClose, id_device, name, confirm } = props;

    const handleConfirm = () => {
        confirm();
        handleClose();
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Desvincular Dispositivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="tac">Está a punto de desvincular el dispositivo {id_device} a { name }.</div>
                <div className="tac separate">¿Desvincular el dispositivo?</div>
                <div className="tac separete">
                    <button className="btn btn-success btn-lgt" onClick={handleConfirm}>Confirmar</button>
                    <button className="btn btn-warning btn-lgt" onClick={ handleClose }> Cancelar </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

ModalConfirm.defaultProps = {
    show: false,
    name: '',
    id_device: '',
    confirm: () => { },
    handleClose: () => { },
}

export default ModalConfirm;